import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components
import SortOptionItem from './SortOptionItem'

// CSS
import '../../../css/sort-section.css'

// Utils
// import '../../../utils/immutability-helper-extend'

class SortOptions extends Component {
    constructor(props){
        super(props)
        this.state = {
            options: props.options
        }
    }

    setAjaxSortParams(value, dir, key){
        // Set active sort option
        this.setState({
            options: this.state.options.map((option, i) => {
                // Reset anything not selected
                if(i !== key){
                    option.isSetViaJS = false
                    option.isDefault = false
                
                // Selected item
                }else{
                    option.isSetViaJS = true
                }

                return option
            })
        })

        // Call store sort.  Value = sort proprty, dir = sort direction, index = index of item in store collection
        this.props.sort(value, dir, this.props.collectionIndex)
    }

    render() {
        return (
            <div className="sort_section">
                <span>Sort:</span>
                {this.state.options.map((option, i) => {
                    return <SortOptionItem option={option} key={i} index={i} setAjaxSortParams={this.setAjaxSortParams.bind(this)} {...this.props} />
                })}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        sortValue: state.sort.value,
        sortDir: state.sort.dir
    }
}

export default connect(mapStateToProps)(SortOptions)



// WEBPACK FOOTER //
// ./src/components/utils/sort-options/SortOptions.js